import { Customer } from '@leid/api-customers'

export const handleGTMDataLayer = (customer: Customer | undefined): void => {
  if (typeof window !== 'undefined' && typeof window.dataLayer !== 'undefined') {
    if (customer && customer.id && customer.fullName && customer.email) {
      window.dataLayer.push({
        userId: customer.id,
        name: customer.fullName,
        email: customer.email,
      })
    }
  }
}
